import LeaderBoardItem from "./LeaderBoardItem";

function LeaderBoard(props) {

    var entries = props.entries;

    const leaderboardItems = entries.map((entry) =>
        <LeaderBoardItem 
                key={entry.id.toString()}
                data={entry}       
        />
    );

    return(
        <div>
            {leaderboardItems}
        </div>
    )

}

export default LeaderBoard;